
export default {
  props: {
    text: {
      default: "",
    },
    //可选项: "Light","Dark"
    theme: {
      default: "Light"
    }
  }
};
